import { BaseIcon } from '../BaseIcon';
import { BaseTooltipTrigger } from '../BaseTooltip';
import React from 'react';
import { TInfoHelperProps } from './InfoHelper.types';
import s from './InfoHelper.module.scss';

export const InfoHelper: React.FC<TInfoHelperProps> = React.memo(function InfoHelper({
  className,
  info,
  size = 12,
}) {
  return (
    <BaseTooltipTrigger
      triggerClassName={className}
      tooltipClassName={s.helperTooltip}
      position="right"
      tooltipChildren={info || ''}
      wordWrap={true}>
      <BaseIcon icon="info-thick" className={s.icon} size={size} />
    </BaseTooltipTrigger>
  );
});
